import React, { useState } from 'react';
import cardImage from '../img/envision/awards/cards/award3.JPG'; // Replace with the correct path to your image
import cardImage2 from '../img/envision/awards/cards/awards1.JPG'; // Replace with the correct path to your image
import cardImage3 from '../img/envision/awards/cards/awards2.JPG'; // Replace with the correct path to your image 
import cardImage4 from '../img/envision/awards/cards/awards4.JPG'; // Replace with the correct path to your imag



const Awardssectioncard = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1 style={{ textAlign: 'center', marginBottom: '15px' }}>
                Across Emerging  <span style={{ color: 'rgb(16 131 158)' }}>Technologies</span>
            </h1>

            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '50px',
                    padding: '20px',
                    backgroundColor: '#fff',
                }}
            >
                {/* Card 1 */}
                <div
                    style={{
                        width: '250px',
                        height: '290px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 0 ? 'rgb(7 134 159)' : '',
                    }}
                    onMouseEnter={() => setHoveredIndex(0)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <img
                        src={cardImage}
                        alt="Card 1"
                        style={{
                            width: '100%',
                            height: '183px',
                            objectFit: 'cover',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            transition: 'opacity 0.3s ease',
                            opacity: hoveredIndex === 0 ? 0.8 : 1,
                        }}
                    />
                    <h1 style={{ fontSize: '20px' }}>Leaders in Automotive Engineering</h1>
                    {/* <p style={{ marginBottom: '10px', color: '#000' }}>Achieving the best performance within the industries we serve</p>
                 */}
                </div>

                {/* Card 2 */}
                <div
                    style={{
                        width: '250px',
                        height: '290px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 1 ? 'rgb(7 134 159)' : '',
                    }}
                    onMouseEnter={() => setHoveredIndex(1)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <img
                        src={cardImage2}
                        alt="Card 2"
                        style={{
                            width: '100%',
                            height: '183px',
                            objectFit: 'cover',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            transition: 'opacity 0.3s ease',
                            opacity: hoveredIndex === 1 ? 0.8 : 1,
                        }}
                    />
                    <h1 style={{ fontSize: '20px', marginTop:'-50px !important' }}>Leaders in Industrial</h1>
                    {/* <p style={{ marginBottom: '10px', color: '#000' }}>Constant Improvements of stakeholders engagement scores</p>
                 */}
                </div>

                {/* Card 3 */}
                <div
                    style={{
                        width: '250px',
                        height: '290px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 2 ? 'rgb(7 134 159)' : '',
                    }}
                    onMouseEnter={() => setHoveredIndex(2)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <img
                        src={cardImage3}
                        alt="Card 3"
                        style={{
                            width: '100%',
                            height: '183px',
                            objectFit: 'cover',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            transition: 'opacity 0.3s ease',
                            opacity: hoveredIndex === 2 ? 0.8 : 1,
                        }}
                    />
                    <h1 style={{ fontSize: '20px' }}>Top 2 in Aerospace</h1>
                    
                    {/* <p style={{ marginBottom: '10px', color: '#000' }}> Continuous building of skill evolving market dynamics</p>
                */}
                </div>
                {/* Card 4 */}
                <div
                    style={{
                        width: '250px',
                        height: '290px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 3 ? 'rgb(7 134 159)' : '',
                    }}
                    onMouseEnter={() => setHoveredIndex(3)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <img
                        src={cardImage4}
                        alt="Card 4"
                        style={{
                            width: '100%',
                            height: '183px',
                            objectFit: 'cover',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            transition: 'opacity 0.3s ease',
                            opacity: hoveredIndex === 3 ? 0.8 : 1,
                        }}
                    />
                    <h1 style={{ fontSize: '20px' }}>Leaders in Telecom Innovation</h1>
                    {/* <p style={{ marginBottom: '10px', color: '#000' }}> Continuous building of skill evolving market dynamics</p>
                 */}
                </div>

            </div>
        </div>
    );
};

export default Awardssectioncard;
